import React, { useState } from "react";
import styled from "styled-components";

const AudioToggleButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border: 1px solid var(--soremo-border);
  border-radius: 50%;

  color: ${props => props.isPlaying ? '#fff' : '#fff'};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  /* From https://css.glass */
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(13px);
  -webkit-backdrop-filter: blur(13px);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const AudioIcon = styled.span`
  font-size: 24px;
  transition: all 0.3s ease;
`;

const OsAudioToggle = ({ isPlaying, onToggle, isVisible }) => {
  if (!isVisible) return null;

  return (
    <AudioToggleButton
      isPlaying={isPlaying}
      onClick={onToggle}
      aria-label={isPlaying ? "オーディオを停止" : "オーディオを再生"}
    >
      <AudioIcon className="material-symbols-rounded">
        {isPlaying ? "volume_up" : "volume_off"}
      </AudioIcon>
    </AudioToggleButton>
  );
};

export default OsAudioToggle;
